import { TYPE_TEAMS } from '@/constants';
import { getRandomInt } from '@/utilities';
import Task from '@/models/Task';

export default class Bug extends Task {
  constructor({ product, parentTask }) {
    super({ product, parentTask });
    this.remainingTime = this.getBaseTime();
    this.debugTimes = 0;
    this.acceptTeamType = TYPE_TEAMS.RD;
    this.isChecked = false;
    this.isVerified = false;
  }

  get isFinished() {
    return this.remainingTime <= 0 || this.debugTimes >= 3;
  }

  // eslint-disable-next-line class-methods-use-this
  getBaseTime() {
    return getRandomInt(1, 5);
  }

  update(productivity) {
    this.updateRemainingTime(productivity);
    if (this.remainingTime <= 0 && this.acceptTeamType !== TYPE_TEAMS.QA) {
      this.setBugFixed();
    }
  }

  updateAcceptTeamType(teamType) {
    this.acceptTeamType = teamType;
  }

  checkBug() {
    this.isChecked = true;
  }

  setBugFixed() {
    this.debugTimes += 1;
    this.remainingTime = getRandomInt(1, 3);
    this.acceptTeamType = TYPE_TEAMS.QA;
  }

  setBugNotPass() {
    this.isChecked = false;
    this.remainingTime = this.getBaseTime();
    this.acceptTeamType = TYPE_TEAMS.RD;
  }

  verify() {
    this.isVerified = true;
  }

  generateSubTasks() {
    // 可能是 bug 產生 fix 或 fix 產生 bug
    return [this];
  }
}
